// extracted by extract-css-chunks-webpack-plugin
module.exports = {"form":"form____koWo","row":"row___ts0L6","full":"full___DQRKg","half":"half___O-lN6"};